import { css } from '@emotion/react'
import styled from '@emotion/styled'
import type { Product } from '@src/type/product'
import { ProductStatusDisplay } from '@src/type/product'
import { IMG_STORAGE_URL, MOTINERS_URL } from '@src/utils/constants'
import { formatPriceByLocale } from '@src/utils/utils'
import { Link } from 'react-router-dom'

type PropsType = {
	product: Product
	onDelete?: () => void
}

const ProductListItem = ({ product, onDelete }: PropsType) => {
	const status = ProductStatusDisplay[product.status]
	return (
		<div css={itemStyle}>
			<div css={itemLeftStyle}>
				{product?.banner_img?.length > 0 && (
					<img
						css={imgStyle}
						src={`${IMG_STORAGE_URL}/commerce/product/banner_img/${product.banner_img[0]}`}
						alt={`${product.title} thumbnail`}
					/>
				)}
			</div>
			<div css={itemMiddleStyle}>
				<div>
					<span css={titleStyle}>{product.title}</span>
				</div>
				<ProductStatus status={product.status}>{status}</ProductStatus>
				{product.lowest_price && (
					<div css={priceStyle}>상품 가격 : {formatPriceByLocale(product.lowest_price, 'ko')}</div>
				)}
				{product.lowest_challenge_price && (
					<div css={priceStyle}>
						챌린지 가격 : {formatPriceByLocale(product.lowest_challenge_price, 'ko')}
					</div>
				)}
			</div>
			<div css={itemRightStyle}>
				<a
					css={rightBtnStyle}
					href={`${MOTINERS_URL}/motishop/product/${product.no}`}
					target="_blank"
					rel="noreferrer"
				>
					상품 링크
				</a>
				<Link css={rightBtnStyle} to={`/product/${product.no}`}>
					상품 상세
				</Link>
				<button
					css={rightBtnStyle}
					type="button"
					onClick={() => {
						if (onDelete) onDelete()
					}}
				>
					상품 삭제
				</button>
			</div>
		</div>
	)
}
const itemStyle = css`
	width: 100%;
	display: flex;
	padding: 1rem 0;
	&:hover {
		background: #eeeeee;
	}
	border-bottom: 1px solid #a1a1a1;
`
const itemLeftStyle = css`
	width: 10rem;
	min-width: 10rem;
	height: 10rem;
	flex: 0 1 auto;
	border-radius: 0.5rem;
	overflow: hidden;
`
const imgStyle = css`
	width: 100%;
	height: 100%;
	object-fit: cover;
`
const itemMiddleStyle = css`
	padding-left: 2rem;
	flex: 1 1 auto;
`

const titleStyle = css`
	font-size: 2rem;
	word-break: break-all;
`
const itemRightStyle = css`
	flex: 0 1 auto;
	min-width: 10.2rem;
`
const rightBtnStyle = css`
	display: block;
	font-size: 1.6rem;
	text-decoration: none;
	color: black;
	border: 1px solid #a1a1a1;
	border-radius: 1rem;
	padding: 0.5rem 0.5rem;
	text-align: center;
	margin-bottom: 0.5rem;
	background: white;
	width: 100%;
`
const priceStyle = css`
	padding: 0.5rem 0;
	font-size: 1.4rem;
`
const ProductStatus = styled.div<{ status: string }>`
	background: ${({ status }) => {
		if (status === 'published') {
			return 'green'
		}
		if (status === 'pending') {
			return 'orange'
		}
		return 'red'
	}};
	display: inline-block;
	color: white;
	border-radius: 1rem;
	padding: 0.5rem;
`
export default ProductListItem
